import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponLandingPageMetaService_GetPageMetaDataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/meta/service.grpc.lazy';
import {GetPageMetaDataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/meta/service.types';
import {Head} from '@aboutyou/head-elements';
import {RouterErrorHandler} from '@aboutyou/router';
import {TrackContentPageView} from '@aboutyou/tracking';
import React, {Fragment, memo} from 'react';
import {
  ensure404Page,
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../shared-deprecated/metaUtils';
import {useEnsureRedirectData} from '../../shared-deprecated/useEnsureRedirectData';

const useMetaData = () => {
  const ensureRedirectData = useEnsureRedirectData();

  return useGrpcRequest(
    CouponLandingPageMetaService_GetPageMetaDataLazy,
    {},
    {
      keepPreviousData: false,
      validateData: ensureRedirectData,
      validateError: ensure404Page,
    },
  );
};

export const CouponLandingPageMeta: React.FC = props => {
  return (
    <DataFetcher
      request={useMetaData()}
      Error={RouterErrorHandler}
      View={MemoView}
      viewProps={props}
    />
  );
};

const View: React.FC<GetPageMetaDataResponse> = ({meta}) => {
  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <Fragment>
      <TrackContentPageView pageTitle={seoData.title} />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </Fragment>
  );
};

const MemoView = memo(View);
